import {useEffect} from 'react'
import {DropFileArea} from '@common/drop-file-area'
import {ChatInputStore} from './chat-input-store'

const attachDropToChat = (store?: ChatInputStore): DropFileArea | null => {
  const chatContainerElement = document.querySelector('.chat-item-cnt')
  if (!chatContainerElement) {
    return null
  }
  const dropArea = DropFileArea.attachTo(chatContainerElement)
  dropArea.onDropAction = async (e: DragEvent) => {
    if (!e.dataTransfer) {
      return
    }
    store?.onChooseFiles(Array.from(e.dataTransfer?.files))
  }
  return dropArea
}

export const useDropFiles = (store?: ChatInputStore): void => {
  useEffect(() => {
    const dropArea = attachDropToChat(store)
    return () => dropArea?.removeBehaviors()
  }, [])
}
